import { Injectable } from '@angular/core';
import { ToastController } from '@ionic/angular';

@Injectable()
export class ToastService {
    private toast: HTMLIonToastElement | null | undefined = undefined;

    constructor(private toastController: ToastController) {
    }

    async showSuccess(message: string, icon?: string, duration?: number) {
        if (this.toast) {
            await this.toast.dismiss();
            this.toast = null;
        }

        this.toast = await this.toastController.create({
            message: message,
            duration: duration || 5000,
            position: 'bottom',
            icon: icon || 'checkmark-outline',
            color: 'success'
        });

        return this.toast.present();
    }

    async showError(message: string, icon?: string, duration?: number) {
        if (this.toast) {
            await this.toast.dismiss();
            this.toast = null;
        }

        this.toast = await this.toastController.create({
            message: message,
            duration: duration || 5000,
            position: 'bottom',
            icon: icon || 'alert-circle-outline',
            color: 'danger'
        });

        return this.toast.present();
    }

    async showWarning(message: string, icon?: string, duration?: number) {
        if (this.toast) {
            await this.toast.dismiss();
            this.toast = null;
        }

        this.toast = await this.toastController.create({
            message: message,
            // duration: duration || 3000,
            position: 'bottom',
            icon: icon || 'alert-circle-outline',
            color: 'primary',
            buttons: [
                {
                    text: 'Ok',
                    role: 'cancel'
                },
            ]
        });

        return this.toast.present();
    }
}
